import React from 'react';
import Page from '../../components/Page';
import { DocumentsDetails } from '../../sections/client-zs/DocumentsDetails';

const Documents = () => (
  <Page title="Dokumenty">
    <DocumentsDetails />
  </Page>
);

export default Documents;
